import React,{ useState } from 'react'
import {
  Input, Select, SelectItem, Checkbox, Button, Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  useDisclosure,
  Link
} from "@heroui/react";
import { useNavigate } from 'react-router-dom';
import { SERVER_URL } from '../../../Config';
import toast from "react-hot-toast";

export default function AdminLogin() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email || !password) {
      setError('Email and password are required.');
      toast.error('Email and password are required.');
      return;
    }

    try {
      const response = await fetch(`${SERVER_URL}/api/AdminLogin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        sessionStorage.setItem('admin', JSON.stringify(data.user));

        setSuccess(`Welcome, ${data.user.email}`);
        toast.success(`Welcome, ${data.user.email}`);

        navigate('/admin/dashboard');
      } else {
        setError(data.message || 'Login failed. Please try again.');
        toast.error(data.message || 'Login failed. Please try again.');
      }
    } catch (err) {
      console.error('Error during login:', err);
      setError('An error occurred. Please try again later.');
      toast.error('An error occurred. Please try again later.');

    }
  };

  return (
    <div className='bg-cover bg-center bg-no-repeat min-h-screen bg-Adminbg'>
      <div className='bg-black bg-opacity-50 min-h-screen'>
        <div className=" flex items-center gap-2 px-4 py-4">
          <div>
            <img src="/assets/Logo/logo.svg" className="w-14" />
          </div>
          <div>
            <p className="font-bold text-lg font-Artemus text-white">Stabilix</p>
          </div>
        </div>
        <div className='mt-10 lg:mt-0'>
          <div className='flex justify-center items-center '>
            <p className='font-bold lg:text-2xl font-Artemus text-white'> Admin Panel</p>
            <img className='lg:w-1/12 w-2/12' src='/assets/other/Settings.svg'></img>
          </div>
          <div className='flex justify-center'>
            <div className='lg:w-[30%] bg-[#1e1e1e] px-7 py-7 rounded-xl border border-white flex flex-col gap-4'>
              <input className='w-full outline-none bg-[#1e1e1e] border border-white rounded-lg py-2 px-2 text-white' placeholder='Email'  value={email}
                onChange={(e) => setEmail(e.target.value)}></input>
              <input className='w-full outline-none bg-[#1e1e1e] border border-white rounded-lg py-2 px-2 text-white' placeholder='Password' value={password}
                onChange={(e) => setPassword(e.target.value)}></input>
              <Checkbox className='' defaultSelected color="default"></Checkbox>
              <Button color="danger" type="submit" className='w-full bg-[#FFF2C2] p-0.5 rounded-full  ' onClick={handleLogin}>
                <div className='w-full font-Artemus  rounded-full p-2'>
                  <p className='font-Artemus font-medium text-center text-black text-xl '>Login</p>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
